export default class Entity extends PIXI.Container {

    get view() {
        return this._view;
    }

    constructor() {
        super();
        this._view = null;
    }

    update(dt) {
    }
}